import API from "../api/manager";
import config from "../api/config";

const getTrackingDetails = (data) => {
  return API({
    method: "POST",
    url: config.urls.gettracking,
    data,
  });
};

export default {
  getTrackingDetails,
};
